/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Go_BackInputs */

const en_error_go_back = /** @type {(inputs: Error_Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Go Back`)
};

const ar_error_go_back = /** @type {(inputs: Error_Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`رجوع`)
};

const bn_error_go_back = /** @type {(inputs: Error_Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফিরে যান`)
};

const de_error_go_back = /** @type {(inputs: Error_Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

const es_error_go_back = /** @type {(inputs: Error_Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver`)
};

const fr_error_go_back = /** @type {(inputs: Error_Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour`)
};

const pt_error_go_back = /** @type {(inputs: Error_Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar`)
};

const zh_error_go_back = /** @type {(inputs: Error_Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回`)
};

const tr_error_go_back = /** @type {(inputs: Error_Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geri Dön`)
};

const ru_error_go_back = /** @type {(inputs: Error_Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вернуться назад`)
};

const pl_error_go_back = /** @type {(inputs: Error_Go_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wróć`)
};

/**
* | output |
* | --- |
* | "Go Back" |
*
* @param {Error_Go_BackInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const error_go_back = /** @type {((inputs?: Error_Go_BackInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Go_BackInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_error_go_back(inputs)
	if (locale === "bn") return bn_error_go_back(inputs)
	if (locale === "de") return de_error_go_back(inputs)
	if (locale === "es") return es_error_go_back(inputs)
	if (locale === "fr") return fr_error_go_back(inputs)
	if (locale === "pt") return pt_error_go_back(inputs)
	if (locale === "zh") return zh_error_go_back(inputs)
	if (locale === "tr") return tr_error_go_back(inputs)
	if (locale === "ru") return ru_error_go_back(inputs)
	if (locale === "pl") return pl_error_go_back(inputs)
	return en_error_go_back(inputs)
});